import { css } from 'aphrodite';
import * as React from 'react';
import { toast } from 'sonner';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { useErrorMessages } from '../../../models/hooks/appStateHooks';
import { useEventLogging } from '../../../models/Logging';
import { useAddContacts } from '../../../queries/AdminTools';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { RoundAddIcon } from '../../../web/components/svgs/icons/RoundAddIcon';
import { TextInput } from '../../../web/components/TextInput';
import { baseStyleSheet } from '../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps {
	onCancelClick: () => void;
}

export function AddContactForm({ onCancelClick }: IProps) {
	const [names, setNames] = React.useState<string[]>(['']);
	const userSession = useAdminUserSession();
	const errorMessages = useErrorMessages();
	const { logApiError } = useEventLogging('AddContactForm');
	const addContactMutation = useAddContacts({
		onError: error => {
			errorMessages.pushApiError(error);
			logApiError('AdminTools-AddContactForm', error);
		},
		onSuccess: () => {
			toast.success('Contacts added successfully');
			onCancelClick();
		},
		userSession,
	});
	const onSaveClick = () => {
		const values = names.filter(name => Boolean(name.trim()));
		if (values.length === 0) {
			return;
		}
		addContactMutation.mutate({ names: values });
	};
	return (
		<div className={css(styleSheet.addContactModalRoot)}>
			<h2 className={css(styleSheet.addContactModalHeader)}>Add contact names</h2>
			{names.map((name, index) => (
				<TextInput
					inputId={`contact-name-${index}`}
					key={index}
					onChange={ev => {
						const newNames = [...names];
						newNames[index] = ev.target.value;
						setNames(newNames);
					}}
					type='text'
					value={name}
				/>
			))}
			<button className={css(styleSheet.addContactModalAddButton)} onClick={() => setNames([...names, ''])}>
				<RoundAddIcon className={css(styleSheet.addContactModalAddButtonIcon)} />
				Add contact name
			</button>
			<div className={css(styleSheet.addContactModalFooter)}>
				<button disabled={addContactMutation.isPending} className={css(baseStyleSheet.ctaButton)} onClick={onSaveClick}>
					{addContactMutation.isPending ? (
						<LoadingSpinner type='tiny' className={css(styleSheet.addContactModalSavingSpinner)} />
					) : null}{' '}
					Save
				</button>
				<button className={css(baseStyleSheet.ctaButtonReverse)} onClick={onCancelClick}>
					Cancel
				</button>
			</div>
		</div>
	);
}
